/* eslint-disable @typescript-eslint/no-explicit-any */
import { Menu, MenuButton, MenuList, MenuItem, Button } from '@chakra-ui/react';
import { FaAngleDown } from 'react-icons/fa';
import React from 'react';

interface Option {
  id: string | number;
  name: string;
}

interface CustomSelectProps {
  label?: string;
  options: Option[];
  value: string | number | null;
  setValue: (value: any) => void;
  placeholder?: string;
  disabled?: boolean;
}

export const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  value,
  setValue,
  placeholder = 'Selecione...',
  disabled = false,
}) => {
  const selectedOption = options.find((item) => item.id == value);

  return (
    <Menu matchWidth>
      <MenuButton
        as={Button}
        variant="outline"
        w="100%"
        h="auto"
        minH="40px"
        px={4}
        py={2}
        fontWeight="normal"
        textAlign="left"
        whiteSpace="normal"
        wordBreak="break-word"
        justifyContent="space-between"
        rightIcon={<FaAngleDown />}
        backgroundColor={disabled ? 'gray.50' : 'white'}
        borderColor={disabled ? 'gray.50' : 'gray.200'}
        _hover={disabled ? {} : { borderColor: 'gray.200' }}
        _active="none"
        cursor={disabled ? 'not-allowed' : 'pointer'}
        color={disabled ? 'gray.500' : 'black'}
      >
        {selectedOption?.name || placeholder}
      </MenuButton>

      {!disabled && (
        <MenuList maxH="300px" overflowY="auto" zIndex={9999}>
          {options.map((o) => (
            <MenuItem
              key={o.id}
              onClick={() => setValue(o.id)}
              whiteSpace="normal"
              wordBreak="break-word"
              textAlign="left"
              bg={value === o.id ? 'blue.50' : 'white'}
              color={value === o.id ? 'blue.700' : 'gray.700'}
              fontWeight={value === o.id ? 'medium' : 'normal'}
              _hover={{
                bg: value === o.id ? 'blue.100' : 'gray.50',
              }}
            >
              {o.name}
            </MenuItem>
          ))}
        </MenuList>
      )}
    </Menu>
  );
};
